export const transformShiftTypes = (value) => {
  if (!value || typeof value !== 'string') {
    return Array.isArray(value) ? value : [];
  }
  const cleanPattern = value.replace(/[{}]/g, '');
  return cleanPattern.split(',').map((item) => item.trim());
};

export const displayShiftTypes = (value) => {
  return transformShiftTypes(value).join(', ');
};

export const EMPTY_VALUE = 'Not set';

export const WEEKDAY_LABELS: Record<string, string> = {
  monday: 'Mon',
  tuesday: 'Tues',
  wednesday: 'Wed',
  thursday: 'Thurs',
  friday: 'Fri',
  saturday: 'Sat',
  sunday: 'Sun',
};

export const getDisplayLines = (values: Array<string | null | undefined>): string[] => {
  const lines = values
    .map((value) => value?.trim())
    .filter((value): value is string => Boolean(value));

  return lines.length > 0 ? lines : [EMPTY_VALUE];
};

export const displayWorkdays = (value) => {
  if (!Array.isArray(value)) {
    return EMPTY_VALUE;
  }
  return getDisplayLines(value.map((day) => WEEKDAY_LABELS[day] ?? day)).join(', ');
};

export const displayLabels = (value) => {
  if (!Array.isArray(value)) {
    return EMPTY_VALUE;
  }
  return getDisplayLines([...new Set(value.map((v) => v.label))]).join(', ');
};

export const displayPositions = (value) => {
  if (!Array.isArray(value)) {
    return EMPTY_VALUE;
  }
  return getDisplayLines([...new Set(value.map((v) => v.display_name))]).join(', ');
};
